import { atom } from 'jotai';
import { ELocalStorage } from 'common/enums/local-storage.enum';
import { getFromLocalstorage } from 'common/utils/local-storage.utils';

export const sidebarCollapsedAtom =
  atom(getFromLocalstorage(ELocalStorage.MenuCollapsed) ?? 'true');
